export const REWARD_LOAD_SUCCESS = 'reward/LOAD_SUCCESS';
export const REWARD_CREATE_SUCCESS = 'reward/CREATE_SUCCESS';
export const SETTINGS_LOAD_SUCCESS = 'reward/SETTINGS_LOAD_SUCCESS';
export const GET_USER_DATA = 'reward/GET_USER_DATA';
